
breezify();

function breezify() {
  addLoginSupport();
  addLogoutSupport();
}

function addLoginSupport() {
  const accountButton = document.getElementById('brz-customer-account');
  if (accountButton) {
    // accountButton.style.display = 'block';
    accountButton.addEventListener('click', () => handleUserLogin());
  }
}

function handleUserLogin() {
  const customerLoggedInOnPlatform = typeof ShopifyAnalytics?.meta?.page?.customerId !== 'undefined';
  const customerLoggedInOnBreeze = localStorage.getItem('sad') !== null;
  if (customerLoggedInOnPlatform && customerLoggedInOnBreeze) window.location.href = '/account';
  else {
    if (customerLoggedInOnBreeze && !customerLoggedInOnPlatform) localStorage.removeItem('sad');
    if (typeof window.openBreezeLoginModal === 'function') window.openBreezeLoginModal(); 
    else console.warn('>>> Please try again after few seconds');
  }
}

function addLogoutSupport() {
  const loguoutButton = document.getElementById('brz-customer-logout');
  if (loguoutButton) {
    // loguoutButton.style.display = 'flex';
    loguoutButton.addEventListener('click', () => handleUserLogout());
  }
}

function handleUserLogout() {
  if (typeof window.breeze?.logout === 'function') {
    window.breeze.logout();
    window.location.href = '/account/logout'; 
  } else console.warn('>>> Please try again after few seconds');
}

function isLocalStorageAvailable() {
  try {
    var storage = window.localStorage;
    var x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return false;
  }
}

function enableBreezeCheckoutFlow() {
  try {
    var storage = window.localStorage;
    return storage.getItem('ghost') === 'migrate';
  } catch (e) {
    return false;
  }
}


// 

function navigateToAccountPageOrOpenBreezeLoginModal(){
    try {
      const customerId = ShopifyAnalytics?.meta?.page?.customerId;
      if(typeof customerId === 'undefined' || (isLocalStorageAvailable() && localStorage.getItem('sad') === null)){
        if(typeof window.openBreezeLoginModal === 'function') {
          window.openBreezeLoginModal(); 
        } else {
          window.location.reload();
        }
      } else{
        window.location.href = '/account';
      }
    } catch (e) {
      console.error(">>> Exception:", e);
    } 
  }